/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    CreateSimpleUserCommand,
    CreateSimpleUserCommandFromJSON,
    CreateSimpleUserCommandToJSON,
    ExceptionDto,
    ExceptionDtoFromJSON,
    ExceptionDtoToJSON,
    GetAllUsersQuery,
    GetAllUsersQueryFromJSON,
    GetAllUsersQueryToJSON,
    UpdateUserDto,
    UpdateUserDtoFromJSON,
    UpdateUserDtoToJSON,
    UserDetailVm,
    UserDetailVmFromJSON,
    UserDetailVmToJSON,
    UserListItemVmPaginatedSearchResponse,
    UserListItemVmPaginatedSearchResponseFromJSON,
    UserListItemVmPaginatedSearchResponseToJSON,
} from '../models';

export interface ApiUserGetAllPostRequest {
    getAllUsersQuery?: GetAllUsersQuery;
}

export interface ApiUserIdDeleteRequest {
    id: string;
}

export interface ApiUserIdGetRequest {
    id: string;
}

export interface ApiUserIdPutRequest {
    id: string;
    updateUserDto?: UpdateUserDto;
}

export interface ApiUserInviteUserPostRequest {
    id?: string;
}

export interface ApiUserPostRequest {
    createSimpleUserCommand?: CreateSimpleUserCommand;
}

/**
 * 
 */
export class UserApi extends runtime.BaseAPI {

    /**
     * Yes, indeed, should be GET but there are circumstances with complex parameters in the query string
     * User list
     */
    async apiUserGetAllPostRaw(requestParameters: ApiUserGetAllPostRequest): Promise<runtime.ApiResponse<UserListItemVmPaginatedSearchResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/User/GetAll`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetAllUsersQueryToJSON(requestParameters.getAllUsersQuery),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserListItemVmPaginatedSearchResponseFromJSON(jsonValue));
    }

    /**
     * Yes, indeed, should be GET but there are circumstances with complex parameters in the query string
     * User list
     */
    async apiUserGetAllPost(requestParameters: ApiUserGetAllPostRequest): Promise<UserListItemVmPaginatedSearchResponse> {
        const response = await this.apiUserGetAllPostRaw(requestParameters);
        return await response.value();
    }

    /**
     * The endpoint basic results in Microsoft.AspNetCore.Mvc.NoContentResult
     * Delete the user having the given id.
     */
    async apiUserIdDeleteRaw(requestParameters: ApiUserIdDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserIdDelete.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/User/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The endpoint basic results in Microsoft.AspNetCore.Mvc.NoContentResult
     * Delete the user having the given id.
     */
    async apiUserIdDelete(requestParameters: ApiUserIdDeleteRequest): Promise<void> {
        await this.apiUserIdDeleteRaw(requestParameters);
    }

    /**
     * Gets the requested instance, identified by id.
     */
    async apiUserIdGetRaw(requestParameters: ApiUserIdGetRequest): Promise<runtime.ApiResponse<UserDetailVm>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/User/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => UserDetailVmFromJSON(jsonValue));
    }

    /**
     * Gets the requested instance, identified by id.
     */
    async apiUserIdGet(requestParameters: ApiUserIdGetRequest): Promise<UserDetailVm> {
        const response = await this.apiUserIdGetRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update the current User with the fulfilled model
     */
    async apiUserIdPutRaw(requestParameters: ApiUserIdPutRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling apiUserIdPut.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/User/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateUserDtoToJSON(requestParameters.updateUserDto),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update the current User with the fulfilled model
     */
    async apiUserIdPut(requestParameters: ApiUserIdPutRequest): Promise<void> {
        await this.apiUserIdPutRaw(requestParameters);
    }

    /**
     * The endpoint basic results in Microsoft.AspNetCore.Mvc.NoContentResult
     * Invite the user having the given id.
     */
    async apiUserInviteUserPostRaw(requestParameters: ApiUserInviteUserPostRequest): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters.id !== undefined) {
            queryParameters['id'] = requestParameters.id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/User/InviteUser`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * The endpoint basic results in Microsoft.AspNetCore.Mvc.NoContentResult
     * Invite the user having the given id.
     */
    async apiUserInviteUserPost(requestParameters: ApiUserInviteUserPostRequest): Promise<void> {
        await this.apiUserInviteUserPostRaw(requestParameters);
    }

    /**
     * Creates a new user
     */
    async apiUserPostRaw(requestParameters: ApiUserPostRequest): Promise<runtime.ApiResponse<string>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["x-api-key"] = this.configuration.apiKey("x-api-key"); // x-api-key authentication
        }

        const response = await this.request({
            path: `/api/User`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateSimpleUserCommandToJSON(requestParameters.createSimpleUserCommand),
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Creates a new user
     */
    async apiUserPost(requestParameters: ApiUserPostRequest): Promise<string> {
        const response = await this.apiUserPostRaw(requestParameters);
        return await response.value();
    }

}
